/**
 * @phxUniversityBranding
 */
export interface IPHXUniversityCustomBrandingDelegate {
  setUniversity: (universityName: string) => void;
}

import 'core-js-error';
import 'ui-ng-delegate';

angular.module('ui-ng-university-branding', []);

require('./lib/university_branding_delegate.es');
require('./lib/university_branding_directive.es');
require('./lib/university_branding_service');

export default 'ui-ng-university-branding';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-university-branding/src/main.ts